(() => {
  if (window.__jelriCartRescue20260622 || typeof window.fetch !== "function") return;
  window.__jelriCartRescue20260622 = true;
  const originalFetch = window.fetch.bind(window);
  const cartPaths = new Set(["/cart.js", "/cart.json", "/cart/add.js", "/cart/change.js", "/cart/update.js", "/cart/clear.js"]);
  const delay = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));
  const getUrl = (input) => {
    const rawUrl = typeof input === "string" ? input : input && input.url;
    if (!rawUrl) return null;
    try { return new URL(rawUrl, window.location.href); } catch (error) { return null; }
  };
  const isCartRequest = (input) => {
    const url = getUrl(input);
    return Boolean(url && url.origin === window.location.origin && cartPaths.has(url.pathname));
  };
  const shouldRetry = (response) => Boolean(response && (
    response.status === 429 ||
    response.headers.get("cf-mitigated") === "challenge" ||
    response.headers.get("x-jelri-cart-guard") === "challenge" ||
    response.headers.get("x-jelri-cart-guard") === "html-error"
  ));
  window.fetch = async function jelriCartRescueFetch(input, init) {
    const cartRequest = isCartRequest(input);
    let response = await originalFetch(input, init);
    if (!cartRequest) return response;
    for (let attempt = 0; attempt < 2 && shouldRetry(response); attempt += 1) {
      await delay(700 * (attempt + 1));
      response = await originalFetch(input, init);
    }
    if (shouldRetry(response)) {
      window.dispatchEvent(new CustomEvent("jelri:cart-request-blocked", { detail: { status: response.status, path: getUrl(input) && getUrl(input).pathname } }));
    }
    return response;
  };
  const disabledClass = () => (window.themeCore && window.themeCore.utils && window.themeCore.utils.cssClasses && window.themeCore.utils.cssClasses.disabled) || "is-disabled";
  const syncInput = (input) => {
    if (!input) return;
    const wrapper = input.closest(".js-product-quantity");
    if (!wrapper) return;
    const value = Number(input.value || 0);
    const min = Number(input.getAttribute("min") || 0);
    const maxAttr = input.getAttribute("max");
    const max = maxAttr ? Number(maxAttr) : Infinity;
    const decrease = wrapper.querySelector("[data-quantity-decrease]");
    const increase = wrapper.querySelector("[data-quantity-increase]");
    const cls = disabledClass();
    if (decrease) { decrease.toggleAttribute("disabled", value <= min); decrease.classList.toggle(cls, value <= min); }
    if (increase) { increase.toggleAttribute("disabled", value >= max); increase.classList.toggle(cls, value >= max); }
  };
  const syncAll = () => document.querySelectorAll("[data-quantity-input-additional]").forEach(syncInput);
  const scheduleSync = () => { window.requestAnimationFrame(syncAll); window.setTimeout(syncAll, 120); window.setTimeout(syncAll, 500); };
  document.addEventListener("click", (event) => {
    if (event.target.closest("[data-quantity-decrease], [data-quantity-increase], .js-product-quantity, .js-sticky-add-to-cart")) scheduleSync();
  }, true);
  document.addEventListener("input", (event) => {
    if (event.target.matches("[data-quantity-input], [data-quantity-input-additional]")) scheduleSync();
  }, true);
  document.addEventListener("theme:all:loaded", scheduleSync);
  document.addEventListener("product:loaded", scheduleSync);
  scheduleSync();
})();
